import { render, staticRenderFns } from "./TranscriptHistory.vue?vue&type=template&id=515edd1c&"
import script from "./TranscriptHistory.vue?vue&type=script&lang=js&"
export * from "./TranscriptHistory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports